import styled from "styled-components";

export const NoTimesheetRequiredWrapper = styled.div`
    text-align: center;
    padding: 6em 0;
    > button {
        margin-top: 1em;
    }
`;
